import Logo from 'assets/img/Aegis-Cloud.svg';
import favicon from 'assets/img/favicon.svg';

export const favLogo = favicon;
export const logo = Logo;
